module.exports = __webpack_public_path__ + "static/images/phone001.7a694ee3.jpg";